<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-row>
        <el-form
          :inline="true"
          :model="searchFormTree"
          :label-position="$device.large ? `top` : `left`"
          label-suffix=":"
          :size="size"
          @submit.native.prevent>
          <el-col :sm="8">
            <!--
              매장 선택은 **트리 선택 창**이 한다(§1-6 다중 모드). 값은 지금까지 보내던 것과 같은
              `', '` join 문자열이라 아래 조회 로직은 그대로다. 옛 서버(트리 API 없음)에서는 종전
              가맹점 검색 + 왼쪽 체크박스 트리로 떨어진다.
            -->
            <el-form-item :label="$t('매장')" v-if="!treeFallback">
              <StorePicker multiple v-model="storeCds" @change="search" @unavailable="onTreeUnavailable" />
            </el-form-item>
            <el-form-item :label="$t('가맹점 검색')" v-else>
              <el-input
                v-model="searchFormTree.storeNm"
                @keyup.enter.native="searchTree"
                clearable
                placeholder="매장명"
                class="input-with-select">
                <template #append>
                  <el-button :size="size" @click="searchTree" icon="el-icon-search"></el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <el-form
          :inline="true"
          :model="searchForm"
          :label-position="$device.large ? `top` : `left`"
          label-suffix=":"
          :size="size"
          @submit.native.prevent>
          <el-col :sm="16">
            <el-form-item :label="$t('기간')">
              <template>
                <el-date-picker
                  v-model="searchForm.seDt"
                  type="daterange"
                  unlink-panels
                  style="width: 260px"
                  :clearable="false"
                  :editable="false"
                  @change="search()"
                  value-format="yyyy-MM-dd"></el-date-picker>
              </template>
            </el-form-item>
            <el-form-item :label="$t('보기')">
              <el-radio-group v-model="searchForm.statisticsTp">
                <el-radio-button :label="$t('매출통계')"></el-radio-button>
                <el-radio-button :label="$t('상품별')"></el-radio-button>
              </el-radio-group>
            </el-form-item>
            <!--                    <el-form-item :label="$t('유형')" v-if="'pay' === searchForm.statisticsTpVal">-->
            <!--                        <el-radio-group v-model="searchForm.periodTp">-->
            <!--                            <el-radio-button :label="$t('결제수단')"></el-radio-button>-->
            <!--                            <el-radio-button :label="$t('주문유형')"></el-radio-button>-->
            <!--                        </el-radio-group>-->
            <!--                    </el-form-item>-->
          </el-col>
        </el-form>
      </el-row>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('StatisticsTreeSearchForCust')"
        :size="size"
        @click="search"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
    </div>

    <el-row :gutter="10">
      <el-col :md="6" v-if="treeFallback">
        <template>
          <el-tree
            :data="treeData"
            show-checkbox
            node-key="cd"
            :props="defaultProps"
            :default-expand-all="true"
            :expand-on-click-node="true"
            ref="treeRef"
            :style="{ height: tableHeight - 12 + 'px' }"
            style="overflow: auto; border: 1px solid #ebeef5; border-radius: 5px; padding: 5px"
            @node-click="handleNodeClick"
            @check-change="treeCheckChange"></el-tree>
        </template>
      </el-col>
      <el-col :md="treeFallback ? 18 : 24">
        <el-row>
          <!-- 매출 -->
          <el-card shadow="never">
            <!-- 리스트 -->
            <template v-if="'pay' === searchForm.statisticsTpVal">
              <el-table
                :height="inputHeight - 40"
                border
                stripe
                highlight-current-row
                tooltip-effect="dark"
                :data="tableData"
                :size="size"
                :empty-text="$t('데이타 없음')">
                <el-table-column
                  :label="$t('매장명')"
                  prop="storeNm"
                  min-width="100"
                  align="center"
                  sortable
                  label-class-name="data_cnt"></el-table-column>
                <el-table-column
                  :label="$t('현금')"
                  prop="payCash"
                  min-width="100"
                  sortable
                  align="right"
                  :formatter="mainVue.formatterNum"></el-table-column>
                <el-table-column
                  :label="$t('카드')"
                  prop="payCard"
                  min-width="120"
                  sortable
                  align="right"
                  :formatter="mainVue.formatterNum"></el-table-column>
                <el-table-column
                  :label="$t('배달앱/기타')"
                  prop="payEtc"
                  min-width="100"
                  sortable
                  align="right"
                  :formatter="mainVue.formatterNum"></el-table-column>
                <el-table-column
                  :label="$t('합계')"
                  prop="totalAmount"
                  min-width="100"
                  sortable
                  align="right"
                  :formatter="mainVue.formatterNum"></el-table-column>
              </el-table>
            </template>

            <template v-if="'smenu' === searchForm.statisticsTpVal">
              <el-table
                :height="inputHeight - 40"
                border
                stripe
                highlight-current-row
                tooltip-effect="dark"
                :data="tableData"
                :size="size"
                :empty-text="$t('데이타 없음')">
                <el-table-column
                  :label="$t('매장명')"
                  prop="storeNm"
                  min-width="100"
                  align="center"
                  sortable
                  label-class-name="data_cnt"></el-table-column>
                <el-table-column
                  :label="$t('상품명')"
                  prop="smenuNm"
                  min-width="100"
                  align="center"
                  sortable></el-table-column>
                <el-table-column
                  :label="$t('수량')"
                  prop="count"
                  min-width="120"
                  sortable
                  align="right"
                  :formatter="mainVue.formatterNum"></el-table-column>
              </el-table>
            </template>
          </el-card>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// 대리점
import StorePicker from '@/components/store/StorePicker.vue'
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import { statisticsAxisRange } from '@/utils/periodFilter'

export default {
  components: { StorePicker },

  mixins: [mainVueMixin],
  data: function () {
    var data = initData()
    data.url = '/cust/statistics'
    data.searchForm = this.initSearchForm()
    data.searchFormTree = this.initSearchFormTree()
    /** 트리 선택 창이 준 매장 집합 — 지금까지 보내던 그대로의 `', '` join 문자열 */
    data.storeCds = ''
    /** 서버가 범위 트리 API 를 모르면(404·403) 옛 체크박스 트리로 떨어진다 */
    data.treeFallback = false

    data.treeData = [
      {
        cd: 0,
        type: '',
        label: 'EMPTY',
        children: [],
      },
    ]
    data.defaultProps = { children: 'children', label: 'label' }
    data.filterText = ''

    return data
  },
  created: function () {
    // 새 경로에서는 트리 선택 창이 스스로 읽는다 — 옛 트리는 폴백으로 떨어질 때만 부른다
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    // 분류 선택 이벤트 — 고른 축의 기본 기간은 `utils/periodFilter` 의 `statisticsAxisRange` 한 곳이 셈한다(KST 달력)
    'searchForm.dateSearchTp': function (newVal) {
      if (this.$t('시간별') == newVal) {
        this.searchForm.dateSearchTpVal = 'HOUR'
      } else if (this.$t('일별') == newVal) {
        this.searchForm.dateSearchTpVal = 'DAY'
      } else if (this.$t('월별') == newVal) {
        this.searchForm.dateSearchTpVal = 'MONTH'
      } else if (this.$t('년별') == newVal) {
        this.searchForm.dateSearchTpVal = 'YEAR'
      }
      Object.assign(this.searchForm, statisticsAxisRange(this.searchForm.dateSearchTpVal, Date.now()))
      this.search()
    },
    // 분류 선택 이벤트
    'searchForm.periodTp': function (newVal) {
      if (this.$t('결제수단') == newVal) {
        this.searchForm.periodTpVal = 'salesTp'
      } else if (this.$t('주문유형') == newVal) {
        this.searchForm.periodTpVal = 'orderTp'
      }
    },
    treeData: function (newVal) {
      if (!this.treeFallback || newVal.length === 0) return
      // 옛 트리는 **폴백으로 떨어진 그 틱에** 그려지지 않는다(el-col 이 다음 틱이다) — 있는지 묻고
      // 없으면 지나가면, 응답이 캐시로 동기에 돌아온 날 첫 노드 자동 체크가 조용히 빠진다
      this.$nextTick(
        function () {
          if (!this.$refs.treeRef) return
          this.$refs.treeRef.setCheckedKeys([newVal[0].cd])
          setTimeout(
            function () {
              this.search()
            }.bind(this),
            500
          )
        }.bind(this)
      )
    },
    'searchForm.statisticsTp': function (newVal) {
      if (this.$t('매출통계') == newVal) {
        this.searchForm.statisticsTpVal = 'pay'
      } else if (this.$t('상품별') == newVal) {
        this.searchForm.statisticsTpVal = 'smenu'
      }
      this.search()
    },
  },
  methods: {
    /**
     * 트리 선택 창이 **「이 서버는 범위 트리를 모른다」**고 알려 왔다 — 옛 체크박스 트리로 떨어진다.
     * 그 트리는 자기 데이터를 아직 안 읽었으므로 여기서 한 번 읽는다(첫 노드 자동 선택도 그때 걸린다).
     */
    onTreeUnavailable: function () {
      this.treeFallback = true
      this.searchTree()
    },

    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        dateSearchTp: this.$t('일별'),
        dateSearchTpVal: 'DAY',
        // seDt: [util.getDate('yyyy-MM-dd HH:mm', util.dateAdd('HOUR ', -2, new Date())), util.getNow('yyyy-MM-dd HH:mm')], // 시간별
        seDt: [util.getDate('yyyy-MM-dd', util.dateAdd('w ', -1, new Date())), util.getNow('yyyy-MM-dd')], // 일별
        statisticsTp: this.$t('매출통계'),
        statisticsTpVal: 'pay',
        startDt: '',
        endDt: '',
        periodTp: this.$t('결제수단'),
        periodTpVal: 'salesTp',
      }
    },
    // 트리 검색 조건
    initSearchFormTree: function () {
      return {
        storeNm: '',
        storeCds: [],
      }
    },
    // 조회
    search: function () {
      var startDateTime = ''
      var endDateTime = ''
      // 년 일때는 설정 안해줌
      if ('DAY' == this.searchForm.dateSearchTpVal) {
        if (null == this.searchForm.seDt || this.searchForm.seDt.length < 2) {
          this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })
          return
        }
        this.searchForm.startDt = this.searchForm.seDt[0]
        this.searchForm.endDt = this.searchForm.seDt[1]
        startDateTime = this.searchForm.startDt + ' 00:00:00'
        endDateTime = this.searchForm.endDt + ' 23:59:59'
      } else if ('MONTH' == this.searchForm.dateSearchTpVal) {
        if (null == this.searchForm.seDt || this.searchForm.seDt.length < 2) {
          this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })
          return
        }
        this.searchForm.startDt = this.searchForm.seDt[0]
        this.searchForm.endDt = this.searchForm.seDt[1]

        const year = this.searchForm.endDt.substring(0, 4)
        const month = this.searchForm.endDt.substring(5, 7)
        const lastDay = new Date(year, month, 0).getDate()

        startDateTime = this.searchForm.startDt + '-01 00:00:00'
        endDateTime = this.searchForm.endDt + '-' + lastDay + ' 23:59:59'
      } else if ('YEAR' == this.searchForm.dateSearchTpVal) {
        if (util.isEmpty(this.searchForm.startDt) || util.isEmpty(this.searchForm.endDt)) {
          this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })
          return
        }
        startDateTime = this.searchForm.startDt + '-01-01 00:00:00'
        endDateTime = this.searchForm.endDt + '-12-31 23:59:59'
      }

      // 매장 축의 원천은 둘이다 — 트리 선택 창(새 경로)과 옛 체크박스 트리(폴백). 보내는 **모양은 같다**
      const storeCds = this.treeFallback
        ? this.$refs.treeRef
            .getCheckedNodes()
            .filter((node) => node.type === 'S')
            .map((node) => node.cd)
            .join(', ')
        : this.storeCds

      var param = {
        storeCds: storeCds,
        startDateTime: startDateTime,
        endDateTime: endDateTime,
      }

      this.mainVue.$axios.search(
        this.url + '/' + this.searchForm.statisticsTpVal,
        param,
        function (result) {
          this.tableData = result.data
        }.bind(this),
        false
      )
    },
    // 트리 조회
    searchTree: function () {
      const params = {
        storeNm: this.searchFormTree.storeNm,
      }
      this.mainVue.$axios.search(
        this.url + '/tree',
        params,
        function (result) {
          if (null != result) {
            this.treeData = result.trees
          }
        }.bind(this),
        false
      )
    },
    // 트리 데이터 생성
    convertData: function (result) {
      var treeData = []

      for (var i = 0, len = result.length; i < len; i++) {
        var tmp = this.convertData(result[i].subCust)

        for (var j = 0, jlen = result[i].stores.length; j < jlen; j++) {
          tmp.push({
            cd: result[i].stores[j].storeCd,
            label:
              result[i].stores[j].storeId +
              ' ' +
              result[i].stores[j].storeNmLan +
              ('N' == result[i].stores[j].useYn ? ' (삭제)' : ''),
            children: null,
          })
        }

        treeData.push({
          cd: result[i].custCd,
          label: result[i].custId + ' ' + result[i].custNm + ('N' == result[i].useYn ? ' (삭제)' : ''),
          children: tmp.length > 0 ? tmp : null,
        })
      }

      return treeData
    },
    // 트리 클릭
    handleNodeClick: function (data) {
      if (data.type === 'C') {
        // 펼치기
      } else if (data.type === 'S') {
        // let checkedNodes = this.$refs.treeRef.getCheckedNodes();
        // let checkedKeys = this.$refs.treeRef.getCheckedKeys();
        // if (checkedKeys.includes(data.cd)) {
        //     let index = checkedNodes.indexOf(data);
        //     if (index > -1) {
        //         checkedNodes.splice(index, 1);
        //     }
        // } else {
        //     checkedNodes.push(data);
        // }
        // this.$refs.treeRef.setCheckedNodes(checkedNodes);
      }
    },
    // 트리 체크 이벤트
    treeCheckChange: function () {
      // console.log('트리 체크');
      if (this.$refs.treeRef.getCheckedNodes().length > 0) {
        // console.log(this.$refs.treeRef.getCheckedNodes());
      } else {
      }
    },
  },
}
</script>
